// extracted by mini-css-extract-plugin
module.exports = {"influencerHero":"Influencer_influencerHero__4Q5is","influencerAvatar":"Influencer_influencerAvatar__JfNbC"};